import { FormLabel, OptionType, SearchableSelect, useDebounce } from "shared";
import { templatesService } from "entities/template";
import { AppLang } from "app";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./issue_type_select.module.scss";

interface IIssueTypeSelectProps {
    startrekQueue?: string;
    value?: string;
    onChange: (value: string | undefined) => void

}

export const IssueTypeSelect: React.FC<IIssueTypeSelectProps> = React.memo(({
                                                                                startrekQueue,
                                                                                value,
                                                                                onChange
                                                                            }) => {
    const t = useComponentsTranslations();
    const { i18n } = useTranslation();
    const debouncedStartrekQueue = useDebounce(startrekQueue, 500);
    const [issueTypeOptions, setIssueTypeOptions] = useState<OptionType[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (debouncedStartrekQueue) {
            setLoading(true);
            templatesService.loadTicketTypes(debouncedStartrekQueue, i18n.language as AppLang).then((res) => {
                setIssueTypeOptions(res.map(type => {
                    return {
                        value: type.key,
                        label: type.display
                    }
                }));
                setLoading(false);
            })
        } else {
            setIssueTypeOptions([])
        }
    }, [debouncedStartrekQueue, i18n.language])

    return <FormLabel title={t("issueType") + " *"}>
        <SearchableSelect
            options={issueTypeOptions}
            loading={loading}
            optionValue={issueTypeOptions.find((o) => o.value === value)}
            onChange={(val) => {
                onChange(val ? val as string : undefined)
            }}
            isMulti={false}
            hideClearIcon={false}
            isSearchable={true}
        />
        <div className={styles.subLabel}>{"* " + t("issueTypeDescription")}</div>
    </FormLabel>
});
